// import { Link } from "gatsby"
import React, { useState, useEffect } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./section-main-banner.scss"
import ModalVideo from "../../../shared/components/modals/modal-video/modal-video"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import { Helmet } from "react-helmet";

const SectionMainBanner = ({ contennInfo, mobile, tiempoBanner }) => {
  const [activeModal, setModal] = useState(-1)
  const [pageLoad, setPageLoad] = useState(false)

  useEffect(() => {
    setPageLoad(true)
  }, [])

  const captureHref = (e, url, isVideo, index) => {
    if (isVideo) {
      e.preventDefault()
      setModal(index)
      return 
    }
    window.open(url, "_blank")
  }

  const userInfoEncrypt= encryptUserInfo()
  const bannerDayalayer = (redirection, name) => {
    pushDataLayerEvent({
      event: "Interacciones - Banners",
      category: "banner_principal",
      action: "click",
      label: redirection || "video",
      banner_name: name,
      location: window.location.href,
      user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  const listItems = contennInfo.map((info, index) => {
    return (
      <a
        className={"f-slider-pos-" + index}
        key={index}
        onClick={e => {
          bannerDayalayer(info.redireccion, info.imagenesDeBanner[mobile ? 1 : 0].description)
          captureHref(e, info.redireccion, info.tipoDeBanner, index)
        }}
      >
        <div className="f-slider-img-mask">
          {index === 0 &&
            <Helmet>
              <link rel="preload" as="image" href={info.imagenesDeBanner[0].file.url} />
              <link rel="preload" as="image" href={info.imagenesDeBanner[1].file.url} />
            </Helmet>
          }
          <img
            loading="eager"
            fetchpriority="high"
            height={
              info.imagenesDeBanner[mobile ? 1 : 0].file.details.image.height
            }
            className="f-slider-image"
            alt={info.imagenesDeBanner[mobile ? 1 : 0].description}
            src={info.imagenesDeBanner[mobile ? 1 : 0].file.url}
          />
        </div>
      </a>
    )
  })

  const NextArrow = props => {
    const { onClick } = props
    return <span className="f-slider-home-bannerppl-next" onClick={onClick} />
  }
  const PrevArrow = props => {
    const { onClick } = props
    return <span className="f-slider-home-bannerppl-prev" onClick={onClick} />
  }

  var settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: tiempoBanner.velocidad_rotacion,
    autoplaySpeed: tiempoBanner.tiempo_rotacion,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  }
  return (
    <div className="f-sectionMainBanner">
      <Slider {...settings} className="f-slider">
        {listItems}
      </Slider>
      {contennInfo.map((info, index) => (
        <ModalVideo
          setModal={setModal}
          key={index}
          info={{ node: info }}
          activeModal={activeModal}
          identify={index}
        />
      ))}
    </div>
  )
}

export default SectionMainBanner
